import { Container, Typography, Box } from "@mui/material";
import { Helmet } from "react-helmet-async";

export default function Impressum() {
  return (
    <Container sx={{ py: 8, color: 'text.primary', maxWidth: '800px' }}>
      <Helmet>
        <title>Impressum | EDEB Estrichbau</title>
      </Helmet>
      
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 4 }}>
        <Typography variant="h3" color="primary">
          Impressum
        </Typography>
        <img src="/logo.png" alt="EDEB-Estrichbau" style={{ height: 80, backgroundColor: "white", padding: "4px", borderRadius: "8px" }} />
      </Box>
      
      <Box sx={{ mt: 4 }}>
        <Typography paragraph sx={{ fontWeight: "bold" }}>
          Angaben gemäß § 5 TMG
        </Typography>
        
        <Typography paragraph>
          EDEB-Estrichbau<br />
          Inhaber: Erkan Demirci<br />
          65760 Eschborn
        </Typography>

        <Typography paragraph sx={{ fontWeight: "bold", mt: 4 }}>
          Kontakt
        </Typography>
        <Typography paragraph>
          Telefon: 0162 4196199<br />
          E-Mail: edeb-estrichbau@web.de
        </Typography>

        <Typography paragraph sx={{ fontWeight: "bold", mt: 4 }}>
          Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV:
        </Typography>
        <Typography paragraph>
          Erkan Demirci
        </Typography>

        <Box sx={{ height: 1, bgcolor: "divider", my: 4 }} />

        <Typography paragraph>
          <strong>Haftung für Inhalte:</strong> Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für
          eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
        </Typography>

        <Typography paragraph>
          <strong>Haftung für Links:</strong> Unser Angebot enthält Links zu externen Websites Dritter,
          auf deren Inhalte wir keinen Einfluss haben.
        </Typography>

        <Typography paragraph>
          <strong>Urheberrecht:</strong> Die Inhalte dieser Seite sind urheberrechtlich geschützt.
        </Typography>
      </Box>
    </Container>
  );
}
